import React, { useState, useCallback } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { TextField, Checkbox } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const setoresMap = {
  'SPCV - Setor de Protocolo e Custódia de Vestígios - ITEP-Natal': 184,
  'NC - Necrotério - ITEP-Natal': 308,
  'STF - Setor de Traumatologia Forense - ITEP-Natal':313,
  'SBF - Setor de Perícias de Balística Forense - ITEP-Natal': 194,
  'SQF - Setor de Química Forense - ITEP-Natal': 197,
  'STF - Setor de Toxicologia Forense - ITEP-Natal': 198,
  'SBIOF - Setor de Biologia Forense - ITEP-Natal': 196,
}

const opcoesSetores = Object.keys(setoresMap)

export const SelectDespacho = ({ setoresSelecionados, setSetoresSelecionados, label, multiplo }) => {
  const [inputSetor, setInputSetor] = useState('')

  const handleChangeInput = useCallback((value) => {
    setInputSetor(value)
  }, [])

  return (
    <AutocompleteNative
      value={multiplo ? setoresSelecionados.map((id) => opcoesSetores.find((setor) => setoresMap[setor] === id)) : opcoesSetores.find((setor) => setoresMap[setor] === setoresSelecionados) || null}
      name="setor"
      noOptionsText="Sem informações"
      required
      multiple={multiplo}
      options={opcoesSetores}
      onChange={(event, newValue) => {
        if (multiplo) {
          const ids = newValue.map((setor) => setoresMap[setor])
          setSetoresSelecionados(ids)
        } else {
          const idSetor = newValue ? setoresMap[newValue] : null
          setSetoresSelecionados(idSetor)
        }
      }}
      getOptionLabel={(option) => option}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
          {option}
        </>
      )}
      renderInput={(params) => <TextField {...params} variant="outlined" label={label} InputLabelProps={{ shrink: true }} value={inputSetor} onChange={(e) => handleChangeInput(e.target.value)} />}
    />
  )
}
